module.exports = __webpack_public_path__ + "static/img/20250327001.93fd3eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250327001.jpg
// module id = 8zqA
// module chunks = 0